module.exports = __webpack_public_path__ + "static/media/sr-SP.574021e0.md";